import React, { useState, useEffect } from "react";
import infocardimg from '../img/oylesine.png'
import kalemlipng from '../img/kalemlipng.png'
import Api from "../common/api";

const Forms = () => {
  const [datas, setData] = useState([])
  const lang = localStorage.getItem("lang");
  React.useEffect(() => {
    Api.get("/Documents/list/5").then((res) => {
      setData(res.data.items)
      // setCurrentTab(res.data.items[res.data.items.findIndex(x => x.Link == activePath)])
    });
  }, []);


  return (

    <div className="kvk-info-container">

      {datas
        ? datas.map((data) => (
          lang == "en" ? (
            data.Name_EN ? (
              <div className="kvk-info-card">
              <div className="info-card-img">
                <img src={data.Image.split(".")[1] == "docx" ? kalemlipng : infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
              </div>
              <div className="kvk-info">
                <h4>{data.Name_EN}</h4>
                <a href={'https://sankoenerji.com.tr' + data.File_En} target="_blank" className="document-download-btn" > Click to review</a >
              </div>
            </div>
         ):""
        ):(                 
          data.Name_TR ? (
        <div className="kvk-info-card">
        <div className="info-card-img">
          <img src={data.Image.split(".")[1] == "docx" ? kalemlipng : infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
        </div>
        <div className="kvk-info">
          <h4>{data.Name_TR}</h4>
          <a href={'https://sankoenerji.com.tr' + data.Image} target="_blank" className="document-download-btn" > İncelemek için tıklayınız </a >
        </div>
      </div>
          ):""
          )
     
        )) : null}

    </div>
  )
}

export default Forms
